export default class SubmitResultsAction
{
    constructor(formId, submittedAnswers)
    {
        this.formId = formId;
        this.submittedAnswers = submittedAnswers;

        this.resolve = null;
        this.reject = null;
    }

    execute()
    {
        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject  = reject;

            this.submitToServer();

        });
    }

    submitToServer()
    {
        axios.post(
            '/wallbrinkcrossmedia/flitzfunnelquizzes/submit',
            {
                quizId: this.formId,
                answers: this.submittedAnswers
                 }
        ).then((response) => {
             this.resolve(response.data);
        }).catch(error => {
            if (typeof error.response !== 'object') {
                this.reject('An unknown error occurred: ' + error);
                return;
            }
            if (!("data" in error.response) || !("message" in error.response.data)) {
                this.reject('An unknown error occurred.');
                return;
            }
            this.reject(error.response.data.message + ' ' + this.getErrorMessages(error.response.data, 'text'));
        });
    }


    getErrorMessages(responseData, field)
    {
        if (!('errors' in responseData) || !(field in responseData.errors)) {
            return '';
        }

        let errors = responseData.errors[field];
        return errors.join(', ');
    }
}
